import { Badge } from "../../../components/ui"
import { Pair } from "../types"

// Limiar "expirando" (dias), o mesmo usado historicamente em daysBadge.
export const EXPIRING_THRESHOLD_DAYS = 30

/**
 * Badge de status por par (plano §7.2):
 * - PROVISIONED           → âmbar  "Provisionado"
 * - ACTIVE + validade longe → verde  "Faturado"
 * - ACTIVE + validade perto → laranja "Expirando (N d)"
 * - ACTIVE + validade passada → vermelho "Expirado"
 * - FREE                  → cinza  "URL livre"
 */
export function pairBadge(
    status: Pair["status"],
    daysRemaining: Pair["days_remaining"]
) {
    if (status === "FREE") return <Badge variant="neutral">URL livre</Badge>
    if (status === "PROVISIONED")
        return <Badge variant="warning">Provisionado</Badge>

    // ACTIVE (ou qualquer status faturável): decidido pela validade.
    if (daysRemaining === null || daysRemaining === undefined)
        return <Badge variant="success">Faturado</Badge>
    if (daysRemaining <= 0) return <Badge variant="danger">Expirado</Badge>
    if (daysRemaining <= EXPIRING_THRESHOLD_DAYS)
        return <Badge variant="orange">Expirando ({daysRemaining} d)</Badge>
    return <Badge variant="success">Faturado</Badge>
}
